// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withFileLock = void 0;
const tslib_1 = require("tslib");
const fs = tslib_1.__importStar(require("fs-extra"));
const proper_lockfile_1 = require("proper-lockfile");
const concurrentLocker_1 = require("./concurrentLocker");
const path_1 = tslib_1.__importDefault(require("path"));
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const utils_1 = require("../../common/utils");
async function withFileLock(filePath, callback) {
    if (!(await fs.pathExists(filePath))) {
        throw new Error(`File not found: ${filePath}`);
    }
    const lockFileDir = (0, concurrentLocker_1.getLockFolder)(filePath);
    const lockfilePath = path_1.default.join(lockFileDir, `${teamsfx_api_1.ConfigFolderName}.lock`);
    await fs.ensureDir(lockFileDir);
    let release = null;
    for (let i = 0; i < 10; i++) {
        try {
            release = await (0, proper_lockfile_1.lock)(filePath, { lockfilePath: lockfilePath });
            break;
        }
        catch (e) {
            if (e.code === "ELOCKED") {
                await (0, utils_1.waitSeconds)(1);
            }
            else {
                throw e;
            }
        }
    }
    if (!release) {
        throw new Error(`Failed to acquire lock on ${filePath} after 10 seconds.`);
    }
    try {
        return await callback();
    }
    finally {
        await release();
    }
}
exports.withFileLock = withFileLock;
//# sourceMappingURL=fileLocker.js.map